import type { OfficeHost } from "@/core/types";

export interface OfficeEnvironment {
  /** In welcher Office-Anwendung läuft das Add-in? `null` = normaler Browser. */
  host: OfficeHost | null;
  /** Desktop, Web oder Mac – nur für Hinweistexte relevant. */
  platform: string | null;
}

const HOST_MAP: Partial<Record<string, OfficeHost>> = {
  Word: "Word",
  Excel: "Excel",
  PowerPoint: "PowerPoint",
};

/**
 * Wartet darauf, dass Office.js einsatzbereit ist.
 *
 * Wird das Panel außerhalb von Office geöffnet (z. B. direkt im Browser während
 * der UI-Entwicklung), meldet die Funktion nach kurzer Wartezeit `host: null`.
 * Die Kursoberfläche kann dann trotzdem angezeigt werden, nur die Prüfungen im
 * Dokument stehen nicht zur Verfügung.
 */
export function initializeOffice(timeoutMs = 3000): Promise<OfficeEnvironment> {
  const fallback: OfficeEnvironment = { host: null, platform: null };

  if (typeof Office === "undefined" || typeof Office.onReady !== "function") {
    return Promise.resolve(fallback);
  }

  const ready = Office.onReady().then((info) => ({
    host: info?.host ? (HOST_MAP[String(info.host)] ?? null) : null,
    platform: info?.platform ? String(info.platform) : null,
  }));

  const timeout = new Promise<OfficeEnvironment>((resolve) => {
    window.setTimeout(() => resolve(fallback), timeoutMs);
  });

  return Promise.race([ready, timeout]);
}
